import { Menu, MenuItemData, MenuProps, MenuRef } from '@cue/molecules';
import { LocalStorageUtil } from '@cue/utility';
import { useNavMenu } from '@project/hooks/use-nav-menu';
import { useQuery } from '@tanstack/react-query';
import { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { MenuItem } from './menu-item';

/* export const HeaderMenu = forwardRef<HTMLDivElement, HeaderMenuProps>(
  ({ slug, onCustomAction, ...rest }, ref) => { */

export const HeaderMenu = forwardRef(function HeaderMenu(
  { slug, onCustomAction, additionalIcon, ...rest }: HeaderMenuProps,
  ref: React.ForwardedRef<unknown>,
) {
  const { data: onsiteMode } = useQuery({
    queryKey: ['onsite-mode'],
    queryFn: () => (LocalStorageUtil.get('onSiteMode') as boolean) || false,
  });

  /* export const HeaderMenu = ({ slug, onCustomAction, ...rest }: HeaderMenuProps) => {
   */ const { menuItems, onsiteMenuItems } = useNavMenu(slug);
  const mobileRef = useRef<MenuRef>(null);
  useImperativeHandle(ref, () => {
    const impReturn: HeaderMenuRef = {
      closeMobile: () => mobileRef?.current?.closeMobile(),
    };
    return impReturn;
  }, []);
  const items = useMemo(
    () =>
      onsiteMode && onsiteMenuItems.length > 0
        ? onsiteMenuItems.map((item) => ({
            ...item,
            render: (menuProps: MenuItemData) => {
              console.log('menuProps', menuProps);
              return (
                <MenuItem
                  {...menuProps}
                  link={menuProps?.link?.replace(/\/(..)\/#/, '/$1/onsite-mode/#')}
                  additionalIcon={additionalIcon}
                  onCustomAction={onCustomAction}
                  onClick={() => mobileRef?.current?.closeMobile()}
                />
              );
            },
          }))
        : menuItems.map((item) => ({
            ...item,
            render: (menuProps: MenuItemData) => (
              <MenuItem
                {...menuProps}
                additionalIcon={additionalIcon}
                onCustomAction={onCustomAction}
                onClick={() => mobileRef?.current?.closeMobile()}
              />
            ),
          })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [menuItems],
  );
  return <Menu {...{ ...rest, items }} ref={mobileRef} />;
});
HeaderMenu.displayName = 'HeaderMenu';

export interface HeaderMenuProps extends Partial<MenuProps> {
  slug: string;
  onCustomAction?(custom_action: string): void;
  additionalIcon?: string;
}
export interface HeaderMenuRef {
  closeMobile?(): void;
}
